var map = {
	"./aiwa.png": "6af0",
	"./aramark.png": "c2c6",
	"./cedars-sinai.png": "6e90",
	"./chartwells.png": "6f46",
	"./compass-group.png": "5bbb",
	"./flik.png": "6d84",
	"./fluor.png": "bd69",
	"./gourmet.png": "989a",
	"./kenwood.png": "f35f",
	"./thompson.png": "a8c2",
	"./trd.png": "7103",
	"./vertex-standard.png": "2125"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6aae";